var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89999 13.9639H2V26.9639H30.2V24.4639",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2001 16.9639V13.9639H8.6001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 13.9637L15.7 7.06369C13.7136 6.05405 11.4424 5.75154 9.26089 6.20601C7.07944 6.66048 5.11801 7.8448 3.70001 9.56369C2.64137 10.7895 2.04056 12.3445 2 13.9637",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0999 23.9635C11.8672 23.9635 13.2999 22.5308 13.2999 20.7635C13.2999 18.9962 11.8672 17.5635 10.0999 17.5635C8.3326 17.5635 6.8999 18.9962 6.8999 20.7635C6.8999 22.5308 8.3326 23.9635 10.0999 23.9635Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 22.8636C21.1597 22.8636 22.0999 21.9234 22.0999 20.7636C22.0999 19.6038 21.1597 18.6636 19.9999 18.6636C18.8401 18.6636 17.8999 19.6038 17.8999 20.7636C17.8999 21.9234 18.8401 22.8636 19.9999 22.8636Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2001 24.4636C29.6563 24.5527 29.0997 24.5224 28.5688 24.375C28.0379 24.2275 27.5454 23.9664 27.1255 23.6097C26.7055 23.2529 26.3682 22.8092 26.1368 22.3091C25.9055 21.809 25.7856 21.2646 25.7856 20.7136C25.7856 20.1626 25.9055 19.6182 26.1368 19.1181C26.3682 18.618 26.7055 18.1742 27.1255 17.8175C27.5454 17.4608 28.0379 17.1996 28.5688 17.0522C29.0997 16.9047 29.6563 16.8745 30.2001 16.9636",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheese);
export default __webpack_public_path__ + "static/media/cheese.b816a4d017345ddcbdc002922526b6b5.svg";
export { ForwardRef as ReactComponent };